// logo is a file in public/images/sponsors/sponsor/. Confirm the tier and logo with the team lead first.
export const SPONSOR_TIERS = [
  {
    id: 'platinum',
    title: 'Platinum Sponsors',
    sponsors: [
      {
        name: 'Momentus Space',
        logo: '/images/sponsors/sponsor/Momentus.png',
        logoAlt: 'Momentus Space',
        description:
          'Founded in 2017, Momentus was born out of countless discussions with satellite operators looking for rides to destinations which weren\'t commercially being offered. Their mission is simple: they want enterprise and existence to flourish in space and they know that creating truly efficient in-space transportation will make that possible.'
      },
      {
        name: 'Simon Fraser Student Society',
        logo: '/images/sponsors/sponsor/sfss.png',
        logoAlt: 'Simon Fraser Student Society',
        description:
          'The Simon Fraser Student Society is a student-led organization that represents and advocates for the interests of the 25,000+ undergraduate students at SFU. They are the not-for-profit support network and voice for students at SFU and provide services and support to make student life better.'
      },
      {
        name: 'AGI',
        logo: '/images/sponsors/sponsor/agi.png',
        logoAlt: 'AGI',
        description:
          'At AGI, they\'ve been crafting breakthroughs since 1989. Their software is integral to the success of hundreds of organizations throughout the aerospace, defense, and telecommunications industries, among others. Some of the most important air, space, and defense programs of the past 30 years have relied on the products they build.'
      }
    ]
  },
  {
    id: 'silver',
    title: 'Silver Sponsors',
    sponsors: [
      {
        name: 'MDA',
        logo: '/images/sponsors/sponsor/mda.png',
        logoAlt: 'MDA',
        description:
          'MDA develops and delivers advanced surveillance and intelligence solutions, defence and maritime systems, radar geospatial imagery, space robotics, satellite antennas, and communication subsystems. From locations across Canada, MDA\'s global reach and heritage serving international markets with innovative and iconic solutions for space and terrestrial applications is unparalleled.'
      },
      {
        name: 'Canadian Space Agency',
        logo: '/images/sponsors/sponsor/csa.png',
        logoAlt: 'Canadian Space Agency',
        description:
          'Established in March 1989, the CSA is a federal agency responsible for managing all of Canada\'s civil space-related activities. The objectives of the Agency are to promote the peaceful use and development of space, to advance the knowledge of space through science and to ensure that space science and technology provide social and economic benefits for Canadians.'
      },
      {
        name: 'SFU Aerospace',
        logo: '/images/sponsors/sponsor/SFUAerospace.jpeg',
        logoAlt: 'SFU Aerospace',
        description:
          'SFU Aerospace is a joint initiative among the three largest aerospace teams at Simon Fraser University: they are an administrative team working to represent each design team in their efforts for funding and resources. Together, they represent over 140 students and their ambitious goals from designing and building satellites, rockets, and autonomous drones.'
      },
      {
        name: 'SFU Faculty of Applied Science',
        logo: '/images/sponsors/sponsor/SFUFAS.png',
        logoAlt: 'SFU Faculty of Applied Science',
        description:
          'In the Faculty of Applied Sciences, they are shaping tomorrow\'s technology leaders in computing science and engineering. They offer challenging areas of study complemented by unique learning experiences to foster a spirit of innovation and entrepreneurship, professional growth and leadership ability.'
      }
    ]
  },
  {
    id: 'bronze',
    title: 'Bronze Sponsors',
    sponsors: [
      {
        name: 'Tallysman Wireless',
        logo: '/images/sponsors/sponsor/tallysman.png',
        logoAlt: 'Tallysman Wireless',
        description:
          'Tallysman® is a developer, manufacturer, and provider of GNSS, Iridium and Globalstar antennas and accessories in support of their customers who are engaged in a broad range of satellite-based positioning, navigation, and data applications. Based in Ottawa Canada, Tallysman is focused on high function, high performance technology and solutions. Their core competencies include digital wireless networks, RF and Global Navigation Satellite Systems (GNSS) component design.'
      },
      {
        name: 'SFU Mechatronic Systems Engineering',
        logo: '/images/sponsors/sponsor/MSE-Logo.jpg',
        logoAlt: 'SFU Mechatronic Systems Engineering',
        description:
          'Mechatronics is a dynamic, multidisciplinary subject combining three engineering fields: mechanical, electrical and software engineering. This highly integrated approach creates smart, inventive and evermore efficient solutions for a wide range of high-tech engineering problems.'
      },
      {
        name: 'SFU Computing Science',
        logo: '/images/sponsors/sponsor/SFUCS.jpg',
        logoAlt: 'SFU Computing Science',
        description:
          'The School of Computing Science follows SFU\'s tradition of excellence in teaching and research. Their research is world-renowned, and their students graduate with advanced knowledge in areas such as networks, multimedia, healthcare and telecommunications. Many graduates apply their broad- based skills as entrepreneurs and business leaders in their field.'
      },
      {
        name: 'SFU Engineering Science',
        logo: '/images/sponsors/sponsor/SFUENSC.jpg',
        logoAlt: 'SFU Engineering Science',
        description:
          'Their students acquire a rich foundation of skills then work with the faculty to drive and develop new ideas within their five main program areas: biomedical engineering, computer engineering, electronics engineering, engineering physics and systems engineering.'
      },
      {
        name: 'Valispace',
        logo: '/images/sponsors/sponsor/valispace.png',
        logoAlt: 'Valispace',
        description:
          'The limits of today\'s engineering are not the imagination of engineers, but the tools for collaboration: the more complex a product becomes, the more engineers need to work together on it. They want small engineering teams to be able to design highly complex systems fast and cheap and big engineering teams to build things which seem like magic to us today.'
      },
      {
        name: 'Digi-Key',
        logo: '/images/sponsors/sponsor/DigiKey.png',
        logoAlt: 'Digi-Key',
        description:
          'Headquartered in Thief River Falls, Minnesota, USA, Digi-Key is one of the fastest growing distributors of electronic components in the world. Today Digi-Key offers the world\'s largest selection of electronic components in stock and available for immediate shipment. From prototype to production, they are here to fuel innovation all over the world.'
      }
    ]
  }
];
